import { Component, input, output } from '@angular/core';

@Component({
    selector: 'app-loading-button',
    imports: [],
    template: `
    <button [class]="'btn btn-' + buttonType() + ' btn-' + buttonType() + '_qai'" [type]="type()" [disabled]="disabled()" (click)="clickButton.emit('clicked')">
      @if (loading()) {
      <span class="spinner-grow spinner-grow-sm me-2" aria-hidden="true"></span>
      }
      <ng-content></ng-content>
    </button>
  `
})
export class LoadingButtonComponent {
  readonly loading = input<boolean>(false);
  readonly disabled = input<boolean>(false);
  readonly type = input<'submit' | 'button'>('submit');
  readonly buttonType = input<'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'>('primary');
  clickButton = output<any>();
}
